module.exports = __webpack_public_path__ + "media/svg-new/forbidden-c720fa96.svg";